export default async (cb, delay) => {
  return new Promise((resolve) => {
    // this is SSR safe as we ware waiting for the timeout
    setTimeout(() => {
      resolve(cb());
    }, delay);
  });
};
